"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _components = require("./components");

var _listDropdown = _interopRequireDefault(require("../list-dropdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SearchDropdown = function SearchDropdown(_ref) {
  var activeValue = _ref.activeValue,
      containerProps = _ref.containerProps,
      items = _ref.items,
      onChangeHandler = _ref.onChangeHandler,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(_listDropdown["default"], {
    activeValue: activeValue,
    containerProps: containerProps,
    items: items,
    onChangeHandler: onChangeHandler,
    searchIcon: /*#__PURE__*/_react["default"].createElement(_components.SearchIcon, {
      fill: "black",
      height: 24,
      width: 24
    }),
    title: /*#__PURE__*/_react["default"].createElement(_components.SearchDropdownTitle, null, title)
  });
};

SearchDropdown.propTypes = {
  activeValue: _propTypes.string,
  containerProps: (0, _propTypes.objectOf)((0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number])),
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    value: _propTypes.string
  })),
  onChangeHandler: _propTypes.func,
  title: _propTypes.string
};
var _default = SearchDropdown;
exports["default"] = _default;